/**
 * <GeneratedActivityCardSkeleton> — une carte d'énoncé pendant que Sam la compose (molecule).
 *
 * La forme de ce qui arrive — le chapitre, les compétences, le titre, l'énoncé, le bouton —, avec
 * ce qu'on sait déjà (la variation) et ce qui se passe, en mots. Il ne pose pas son balayage :
 * `<GeneratedActivityResults>` en pose un pour la rangée.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Badge } from "../../atoms/Badge"
import { pushButtonBoxHeight } from "../../atoms/Buttons/Button/Button"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { SubjectBadgeSkeleton } from "../../atoms/SubjectBadge"
import { Text } from "../../atoms/typography/Text"
import { Card } from "../Card"
import { RichTextSkeleton } from "../RichText/RichTextSkeleton"

export type GeneratedActivityCardSkeletonProps = {
    /** La variation demandée — « Même type » —, connue avant l'énoncé. */
    variationLabel?: string
    testID?: string
}

export function GeneratedActivityCardSkeleton({ variationLabel, testID }: GeneratedActivityCardSkeletonProps) {
    return (
        <Card p="4" testID={testID}>
            <Stack gap="3">
                <Row gap="2" align="center">
                    <SubjectBadgeSkeleton />
                    <Skeleton textSize="text-sm" width={160} />
                </Row>
                <Card background="surface-subtle" elevation="none" p="3">
                    <Skeleton textSize="text-sm" />
                    <Skeleton textSize="text-sm" width="60%" />
                </Card>
                <Row gap="2" align="center" style={styles.chips}>
                    {variationLabel != null && <Badge text={variationLabel} variant="neutral" />}
                    <Text size="text-sm" color="text-muted">
                        Génération en cours...
                    </Text>
                </Row>
                <Skeleton textSize="text-lg" width={220} />
                <RichTextSkeleton lines={3} />
                <Skeleton shape="block" height={pushButtonBoxHeight("md")} />
            </Stack>
        </Card>
    )
}

const styles = StyleSheet.create(() => ({
    chips: { flexWrap: "wrap" as const },
}))
